import {
  getInitialDate,
  isLess,
  joinISODateAndTimeString,
  showDiff,
} from '@/services/dateTime/datetimeService';

export default {
  data() {
    return {
      minDate: getInitialDate(),
      isDateInvalid: false,
      isInitialDateInvalid: false,
      isFinalDateInvalid: false,
      isMinDateInvalid: false,
      isInitialMinDateInvalid: false,
      isFinalMinDateInvalid: false,
      isDateRelationInvalid: false,
      isDateIntervalInvalid: false,
    };
  },
  computed: {
    isSameDate() {
      return showDiff(this.initialDate, this.finalDate, 'days').days === 0;
    },
    initialDateTime() {
      if (!this.initialDate || !this.initialTime) return null;

      return this.addTimeToDate(this.initialDate, this.initialTime, this.timeZone);
    },
    finalDateTime() {
      if (!this.finalDate || !this.finalTime) return null;

      return this.addTimeToDate(this.finalDate, this.finalTime, this.timeZone);
    },
  },
  methods: {
    addTimeToDate(date, time, timeZone) {
      const opts = { timeZone };
      return joinISODateAndTimeString(date, time, opts);
    },
    validateDate(value, field, minDateErrorCallback, dateRelationErrorCallback) {
      this.isInitialDateInvalid = field === 'initial-date' ? false : this.isInitialDateInvalid;
      this.isFinalDateInvalid = field === 'final-date' ? false : this.isFinalDateInvalid;
      this.isDateInvalid = this.validateDateRelation(dateRelationErrorCallback);

      this.isDateInvalid = this.validateMinDate(value, field, minDateErrorCallback)
        || this.isDateInvalid;

      if (this.isDateInvalid || this.areDatesBeforeMinDate()) {
        this.isInitialDateInvalid = field === 'initial-date' ? true : this.isInitialDateInvalid;
        this.isFinalDateInvalid = field === 'final-date' ? true : this.isFinalDateInvalid;
        return;
      }

      this.$emit('update:invalid', false);
    },
    validateMinDate(value, field, errorCallback) {
      this.isMinDateInvalid = false;
      this.isInitialMinDateInvalid = field === 'initial-date'
        ? false
        : this.isInitialMinDateInvalid;
      this.isFinalMinDateInvalid = field === 'final-date'
        ? false
        : this.isFinalMinDateInvalid;

      if (isLess(value, this.minDate)) {
        if (errorCallback) {
          errorCallback(field);
        }
        this.isMinDateInvalid = true;
        this.isInitialMinDateInvalid = field === 'initial-date'
          ? true
          : this.isInitialMinDateInvalid;
        this.isFinalMinDateInvalid = field === 'final-date'
          ? true
          : this.isFinalMinDateInvalid;
      }

      return this.isMinDateInvalid;
    },
    areDatesBeforeMinDate() {
      const initialDateIsBeforeMinDate = isLess(this.initialDateTime, this.minDate);
      const finalDateIsBeforeMinDate = isLess(this.finalDateTime, this.minDate);
      return initialDateIsBeforeMinDate || finalDateIsBeforeMinDate;
    },
    validateDateRelation(errorCallback) {
      this.isDateRelationInvalid = false;
      const initialMs = this.initialDateTime;
      const finalMs = this.finalDateTime;
      if (isLess(finalMs, initialMs)) {
        if (errorCallback) {
          errorCallback();
        }
        this.isDateRelationInvalid = true;
      }
      return this.isDateRelationInvalid;
    },
    validateDateInterval(interval, type = 'seconds', errorCallback) {
      const types = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
      this.isDateIntervalInvalid = false;

      if (types.indexOf(type) === -1) {
        throw new Error('Type must be years, months, weeks, days, hours, minutes, or seconds.');
      }

      const diffInDays = showDiff(this.finalDateTime, this.initialDateTime, type).days;
      if (diffInDays < interval) {
        if (errorCallback) {
          errorCallback();
        }
        this.isDateIntervalInvalid = true;
      }
      return this.isDateIntervalInvalid;
    },
  },
};
